export default {
  BusinessStockDistributionQtyAddWarehouse: {
    basicInformation: '基础信息',
    supportWarehouseType: '供货仓类型:',
    supportWarehouseId: '供货仓名称:',
    realPosition: '实仓',
    supportWarehouseCode: '供货仓编码:',
    commodityDetails: '商品明细',
    addGoods: '添加商品',
    receivingWarehouse: '接收仓库',
    qtyVirtual: '添加数量虚仓',
    interlineVirtual: '添加中转虚仓',
    title: '选择接收仓',
    receiveWarehouseCodeText: '请输入接收仓编码',
    receiveWarehouseNameText: '请输入接收仓名称',
    selectCommodity: '选择商品',
    // spuNameText: '请输入商品名称',
    // spuCodeText: '请输入商品编码',
    skuCodeText: '请输入SKU编码',
    categoryIdText: '请选择分类',
    msgWaring1: '请先选择商品',
    msgWaring2: '请先选择接收仓库',

    table: {
      categoryName: '商品分类',
      // spuCode: '商品编码',
      // spuName: '商品名称',
      skuCode: 'SKU编码',
      receiveTypeCode: '仓库类型',
      receiveCode: '仓库编码',
      receiveName: '仓库名称',
      distributionQty: '仓位数量',
     }
  }
};
